import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  CardActions,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../button/button';

interface InfoCardProps {
  headerImage: string;
  title: string;
  buttonLabel: string;
  buttonUrl?: string;
}

export const InfoCard = ({
  headerImage,
  title,
  buttonLabel,
  buttonUrl,
}: InfoCardProps): JSX.Element => {
  const navigator = useNavigate();
  const theme = useTheme();

  return (
    <Card
      sx={{
        background: theme.palette.primary.main,
        borderRadius: 4,
        minWidth: '180px',
        color: theme.palette.text.secondary,
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <CardHeader
        title={
          headerImage || (
            <svg
              width="39"
              height="39"
              viewBox="0 0 39 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="19.5"
                cy="19.5"
                r="19.3766"
                fill={theme.palette.secondary.main}
                stroke={theme.palette.secondary.main}
                strokeWidth="0.246835"
              />
              <path
                d="M25.8498 24.3276V13.6725C25.8498 12.8354 25.1648 12.1504 24.3276 12.1504H13.6725C12.8354 12.1504 12.1504 12.8354 12.1504 13.6725V24.3276C12.1504 25.1648 12.8354 25.8498 13.6725 25.8498H24.3276C25.1648 25.8498 25.8498 25.1648 25.8498 24.3276ZM16.3363 20.1417L18.239 22.4325L20.9028 19.0001L24.3276 23.5665H13.6725L16.3363 20.1417Z"
                fill={theme.palette.primary.main}
              />
            </svg>
          )
        }
      />
      <CardContent sx={{ minHeight: 135 }}>
        <Typography gutterBottom variant="h5" fontWeight="bold">
          {title}
        </Typography>
      </CardContent>
      <CardActions
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          alignItems: 'center',
        }}
      >
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          sx={{ mb: 1 }}
          size="small"
          onClick={() => {
            if (buttonUrl) navigator(buttonUrl);
          }}
          label={buttonLabel}
        />
      </CardActions>
    </Card>
  );
};
